import { Modal } from "react-bootstrap";
import "./registrationsuccessmodal.scss";
import cross from "images/cross.svg";
import success from "images/success.svg";

const RegistrationSuccessModal = ({ ...props }) => {
  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered backdrop="static">
      <Modal.Body className="success-modal">
        <p>
          <img src={cross} className="success-modal-crossimg" onClick={props.onHide} alt="" />
        </p>
        <p className="success-modal-title">Вы зарегистрированы.</p>
        <p className="success-modal-title">Добро пожаловать в систему!</p>
        <img src={success} className="success-modal-img" onClick={props.onHide} alt="" />
      </Modal.Body>
    </Modal>
  );
};

export default RegistrationSuccessModal;
